import { NotificationTypes } from '../../enums/notificationTypes';

export const userManagerServiceMessages = {
  USERS: {
    GET_ERROR: 'Unable to get users',
    GET_DETAILS_ERROR: 'Unable to load this user',
    UPDATE_ERROR: 'Unable to update user',
    DELETE_ERROR: 'Unable to delete user',
    CREATE_ERROR: 'Unable to create user. Please try again.',
    CREATE_GROUP_ERROR: 'Unable to create group',
  },
};

export const ERROR_CODE_NOTIFICATION_TYPE: Record<string, NotificationTypes> = {
  QUOTA_EXCEEDED: NotificationTypes.WARNING,
  EMAIL_DUPLICATE: NotificationTypes.WARNING,
  GROUP_DUPLICATE: NotificationTypes.WARNING,
};
